import { Component, OnInit } from '@angular/core'
import { SavedCartService } from '../saved-cart.service'

@Component({
  standalone: false,
  selector: 'vs-custom-global-msg',
  templateUrl: './custom-global-msg.component.html',
  styleUrls: ['./custom-global-msg.component.scss'],
})
export class CustomGlobalMsgComponent implements OnInit {
  constructor(private savedCartService: SavedCartService) {}

  ngOnInit(): void {}

  closeMsg() {
    this.savedCartService.maxSavedCartErrorNotification.next(false)
  }
}
